import React, { useMemo } from "react";
import { SubSectionText } from "features/AdminPanel/modules/SubSectionText/SubSectionText";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import styles from "./SubSectionUnlockedStyles.module.css";
import classnames from "classnames";
import { CommonToggleSectionSwitch } from "../CommonToggleSectionSwitch/CommonToggleSectionSwitch";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { hasMenuPermission } from "utils/AuthUtil";
import { useMenuPermissionsStore } from "features/Account/store/useMenuPermissionsStore";

export const SubSectionUnlocked = ({ subSection = {} }) => {
  const {
    key,
    customRightJSX,
    hideSubsectionText = false,
    customFooter,
    classes = {},
    permissionKey,
    lockCustomRightJSX,
  } = subSection;
  const menuPermissions = useMenuPermissionsStore(
    (state) => state.menuPermissions
  );

  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[key] || {};
  const { status } = subSectionConfig;

  const isLocked = useMemo(
    () => permissionKey && menuPermissions && !hasMenuPermission(permissionKey),
    [permissionKey, menuPermissions]
  );

  if (status === FEATURE_STATUS.HIDDEN) return <></>;
  return (
    <div className={styles.wrapper}>
      <div
        className={classnames(
          styles.subSectionInnerWrapper,
          styles[classes.subSectionInnerWrapper]
        )}
      >
        {!hideSubsectionText && (
          <SubSectionText
            subSectionConfig={{ ...subSection, ...subSectionConfig }}
          />
        )}
        {isLocked && lockCustomRightJSX
          ? lockCustomRightJSX
          : customRightJSX || <CommonToggleSectionSwitch subSectionKey={key} />}
      </div>
      {customFooter}
    </div>
  );
};
